import React, { useState, useEffect } from "react";
import { Table, Input, notification, Button } from "antd";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import "./Orders.css";
import { ExchangeRequestService } from "../../services/ExchangeRequestService";
import { NumericFormat } from 'react-number-format';

const Orders = () => {
    const [searchText, setSearchText] = useState("");
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            const response = await ExchangeRequestService.getAllExchangeRequests();
            setOrders(response);
        } catch (error) {
            notification.error({
                message: 'Process Failed',
                description: error.response?.data || 'An error occurred while getting orders.',
            });
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {title: "Order ID", dataIndex: "id", key: "id"},
        {title: "Request Number", dataIndex: "requestNumber", key: "requestNumber"},
        {
            title: "Give",
            dataIndex: "give",
            key: "give",
            render: (_, record) => (
                <NumericFormat
                    value={record.giveAmount}
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={record.giveCurrency === 'BTC' ? 8 : 2}
                    suffix={` ${record.giveCurrency}`}
                />
            )
        },
        {
            title: "Rate",
            dataIndex: "rate",
            key: "rate",
            render: (rate) => <NumericFormat value={rate} thousandSeparator={true} displayType="text" decimalScale={6} />
        },
        {
            title: "Receive",
            dataIndex: "receive",
            key: "receive",
            render: (_, record) => (
                <NumericFormat
                    value={record.receiveAmount}
                    displayType="text"
                    thousandSeparator={true}
                    decimalScale={record.receiveCurrency === 'BTC' ? 8 : 2}
                    suffix={` ${record.receiveCurrency}`}
                />
            )
        },
        {title: "Owner Name", dataIndex: "ownerName", key: "ownerName"},
        {title: "Bank Name", dataIndex: "bankName", key: "bankName"},
        {title: "Account Number", dataIndex: "accountNumber", key: "accountNumber"},
        {title: "Wallet Address", dataIndex: "walletAddress", key: "walletAddress"},
    ];

    const formattedOrders = orders.map(order => ({
        ...order,
        give: `${order.giveAmount} ${order.giveCurrency}`,
        receive: `${order.receiveAmount} ${order.receiveCurrency}`
    }));

    const filteredData = formattedOrders.filter(order =>
        order.requestNumber.toString().includes(searchText)
    );

    return (
        <div className="orders-container">
            <div className="orders-header">
                <Button
                    type="primary"
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate("/")}
                    className="back-button"
                >
                    Go to App
                </Button>
                <h2 className="orders-title">Orders</h2>
            </div>

            <div className="search-container">
                <Input
                    placeholder="Search by Request Number"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{width: 250, marginBottom: 20, maxWidth: 250}}
                />
            </div>

            <Table
                columns={columns}
                dataSource={filteredData}
                rowKey="id"
                loading={loading}
                pagination={{pageSize: 10}}
            />
        </div>
    );
}

export default Orders;